import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = styled.label`
  margin: 0 0 8px;
  font-size: 14px;
  color: #787878;
	cursor: pointer;
	white-space: nowrap;
`;

const Checkbox = styled.input`
  margin: 2px 8px 0 0;
`;

const FilterOption = props => {
	const id = 'header-filter-' + props.id;
	const checked = props.selected ? 'checked' : '';

	return <Label htmlFor={id}>
		<Checkbox
			type="checkbox"
			name={props.id}
			id={id}
			checked={checked}
			onChange={props.checkHandler}
			value={true} />
		{props.name}
	</Label>;
}

FilterOption.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	selected: PropTypes.bool,
	checkHandler: PropTypes.func,
}

export default FilterOption
